<template>
    <div class="vm-step">
        <div class="step-item"
             :class="{on : step >= i + 1}"
             v-for="(item,i) in list" :key="i">
            <div class="step-index flex-box flex-center">
                <template v-if="step < i + 2">{{i + 1}}</template>
                <template v-else><i class="afd afd-check"></i></template>
            </div>
            <div class="mt16">{{item.name}}</div>
        </div>
        <div class="line-box flex-box">
            <div class="line"
                 :class="{on: step >= i + 1}"
                 v-for="i in list.length - 1"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'step',
    props: {
        step:{
            default(){
                return 1
            }
        },
        // list:{
        //     default(){
        //         return [
        //             {name:'创作详细'},
        //             {name:'赞助方案'},
        //             // {name:'提现方式'}
        //         ]
        //     }
        // },
    },
    components:{
    },
    data() {
        return {
          list:[
                {name: this.$t('c.Step.text1')},
                {name: this.$t('c.Step.text2')},
                // {name:'提现方式'}
            ]
        }
    },
    computed:{
        line_width(){
        }
    },
    mounted() {
    },
    methods: {

    }
};
</script>

<style lang="stylus" scoped>
.vm-step{
    position relative
    display flex
    justify-content space-between
    color $black-5
    .step-item{
        z-index 1
        .step-index{
            width px2rem(32)
            height px2rem(32)
            background $white
            border-radius 10000px
            border 2px solid $black-5
            margin 0 auto
            &.on{
                border-color $purple
            }
        }
        &.on{
            color $purple
            .step-index{
                border-color $purple
            }
            .line{
                background-color $purple
            }
        }
    }
    .line-box{
        position absolute
        top px2rem(16)
        left 5%
        width 89%
        .line{
            height px2rem(2)
            background-color $black-5
            &.on{
                background-color $purple
            }
        }
    }


}
</style>
